// // App.js (React Component)
// import React, { useState } from 'react';
// import axios from 'axios';
// import { Button, Table, Form, Container, Row, Col } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar'
// function Report() {
//     const [date_1, setDate1] = useState('');
//     const [date_2, setDate2] = useState('');
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const handleDateSubmit = async () => {
//         if (date_1 && date_2) {
//             setLoading(true);
//             try {
//                 const response = await axios.post('https://posapi.emedha.in/api/api/filter', {
//                     date_1,
//                     date_2
//                 });
//                 setData(response.data);
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//             setLoading(false);
//         } else {
//             alert('Please select both dates');
//         }
//     };

//     const handleGeneratePDF = async () => {
//         try {
//             const response = await axios.post('https://posapi.emedha.in/api/api/generate-pdf', {
//                 date_1,
//                 date_2
//             });

//             alert(response.data.message); // You can customize this to show a download link
//             console.log('PDF generated:', response.data.filePath);
//         } catch (error) {
//             console.error('Error generating PDF:', error);
//         }
//     };

//     return (
//         <>
//         <Sidebar />
//         <div id='main'>

       
//         <Container>
//             <Row className="mt-3">
//                 <Col md={5}>
//                     <Form.Group>
//                         <Form.Label>From Date</Form.Label>
//                         <Form.Control
//                             type="date"
//                             value={date_1}
//                             onChange={(e) => setDate1(e.target.value)}
//                         />
//                     </Form.Group>
//                 </Col>
//                 <Col md={5}>
//                     <Form.Group>
//                         <Form.Label>To Date</Form.Label>
//                         <Form.Control
//                             type="date"
//                             value={date_2}
//                             onChange={(e) => setDate2(e.target.value)}
//                         />
//                     </Form.Group>
//                 </Col>
//                 <Col md={2} className="d-flex align-items-end">
//                     <Button variant="success" onClick={handleDateSubmit}>Submit</Button>
//                 </Col>
//             </Row>

//             <Row className="mt-3">
//                 <Col>
//                     <Table striped bordered hover>
//                         <thead>
//                             <tr>
//                                 <th>Customer Name</th>
//                                 <th>Mobile Number</th>
//                                 <th>Amount</th>
//                                 <th>Pooja Name</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {loading ? (
//                                 <tr><td colSpan="4">Loading...</td></tr>
//                             ) : (
//                                 data.map((row, index) => (
//                                     <tr key={index}>
//                                         <td>{row.customerName}</td>
//                                         <td>{row.mobileNumber}</td>
//                                         <td>{row.amount}</td>
//                                         <td>{row.poojaname}</td>
//                                     </tr>
//                                 ))
//                             )}
//                         </tbody>
//                     </Table>

//                     <div className="text-center">
//                         <Button variant="primary" onClick={handleGeneratePDF}>Generate PDF</Button>
//                     </div>
//                 </Col>
//             </Row>
//         </Container>

//         </div>
//         </>
//     );
// }

// export default Report;


// import React, { useState } from 'react';
// import axios from 'axios';
// import { Button, Table, Form, Container, Row, Col } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar';

// function Report() {
//     const [date_1, setDate1] = useState('');
//     const [date_2, setDate2] = useState('');
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const handleDateSubmit = async () => {
//         if (date_1 && date_2) {
//             setLoading(true);
//             try {
//                 const response = await axios.post('https://posapi.emedha.in/api/api/filter', {
//                     date_1,
//                     date_2
//                 });
//                 setData(response.data);
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//             setLoading(false);
//         } else {
//             alert('Please select both dates');
//         }
//     };

//     const handleGeneratePDF = () => {
//         const printContent = document.getElementById('printable-table').innerHTML;  // Get the table HTML content
//         const printWindow = window.open('', '', 'height=600,width=800');  // Open a new print window
//         printWindow.document.write('<html><head><title>Print</title><style>');
//         printWindow.document.write(`
//             body { font-family: Arial, sans-serif; }
//             table { width: 100%; border-collapse: collapse; }
//             table, th, td { border: 1px solid black; }
//             th, td { padding: 8px; text-align: left; }
//         `);
//         printWindow.document.write('</style></head><body>');
//         printWindow.document.write(printContent);  // Insert the table HTML into the print window
//         printWindow.document.write('</body></html>');
//         printWindow.document.close();
//         printWindow.print();  // Trigger the print dialog
//     };

//     return (
//         <>
//             <Sidebar />
//             <div id="main">
//                 <Container>
//                 <h3>Pooja Ticket Booking Report</h3>
//                     <Row className="mt-3">
                   
//                         <Col md={5}>
//                             <Form.Group>
//                                 <Form.Label>From Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     value={date_1}
//                                     onChange={(e) => setDate1(e.target.value)}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={5}>
//                             <Form.Group>
//                                 <Form.Label>To Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     value={date_2}
//                                     onChange={(e) => setDate2(e.target.value)}
//                                 />
//                             </Form.Group>
//                         </Col>
//                         <Col md={2} className="d-flex align-items-end">
//                             <Button variant="success" onClick={handleDateSubmit}>
//                                 Submit
//                             </Button>
//                         </Col>
//                     </Row>

//                     <Row className="mt-3">
//                         <Col>
//                             {/* Wrap the table with the ID 'printable-table' */}
//                             <div id="printable-table">
//                                 <Table striped bordered hover>
//                                     <thead>
//                                         <tr>
//                                             <th>Customer Name</th>
//                                             <th>Mobile Number</th>
//                                             <th>Amount</th>
//                                             <th>Pooja Name</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {loading ? (
//                                             <tr>
//                                                 <td colSpan="4">Loading...</td>
//                                             </tr>
//                                         ) : (
//                                             data.map((row, index) => (
//                                                 <tr key={index}>
//                                                     <td>{row.customerName}</td>
//                                                     <td>{row.mobileNumber}</td>
//                                                     <td>{row.amount}</td>
//                                                     <td>{row.poojaname}</td>
//                                                 </tr>
//                                             ))
//                                         )}
//                                     </tbody>
//                                 </Table>
//                             </div>

//                             <div className="text-center">
//                                 <Button variant="primary" onClick={handleGeneratePDF}>
//                                     Print
//                                 </Button>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Container>
//             </div>
//         </>
//     );
// }

// export default Report;




import React, { useState, useMemo, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../Sidebar/Sidebar';

// Self-contained SVG Icons
const Icons = {
  Search: (size = 16) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  ),
  FileBarChart: (size = 16) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="12" y1="18" x2="12" y2="12"></line>
      <line x1="8" y1="18" x2="8" y2="15"></line>
      <line x1="16" y1="18" x2="16" y2="9"></line>
    </svg>
  ),
  IndianRupee: (size = 20) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 3h12"></path>
      <path d="M6 8h12"></path>
      <path d="M6 13l8.5 8"></path>
      <path d="M6 13h3a4 4 0 0 0 0-8"></path>
    </svg>
  ),
  Ticket: (size = 20) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"></path>
      <path d="M13 5v2"></path>
      <path d="M13 17v2"></path>
      <path d="M13 11v2"></path>
    </svg>
  ),
  Users: (size = 20) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  TrendingUp: (size = 20) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  )
};

function Report() {
  const [date_1, setDate1] = useState('');
  const [date_2, setDate2] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);

  // Responsive state
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDateSubmit = async () => {
    if (date_1 && date_2) {
      setLoading(true);
      try {
        const response = await axios.post('https://posapi.emedha.in/api/api/filter', {
          date_1,
          date_2
        });
        setData(response.data || []);
        setCurrentPage(1);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      setLoading(false);
    } else {
      alert('Please select both dates');
    }
  };

  const handleGeneratePDF = () => {
    const printContent = document.getElementById('printable-table').innerHTML;
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Pooja Ticket Booking Report</title>');
    printWindow.document.write(`
      <style>
        body { font-family: system-ui, -apple-system, sans-serif; background-color: #ffffff; padding: 20px; color: #111827; }
        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        th, td { border: 1px solid #fed7aa; padding: 10px 14px; text-align: left; font-size: 13px; }
        th { background-color: #fff7ed; color: #c2410c; font-weight: bold; }
        .text-right { text-align: right; }
      </style>
    `);
    printWindow.document.write('</head><body>');
    printWindow.document.write(printContent);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  // Filter records based on search query
  const filteredData = useMemo(() => {
    return data.filter((row) => {
      const q = searchQuery.toLowerCase();
      return (
        (row.customerName && row.customerName.toLowerCase().includes(q)) ||
        (row.mobileNumber && row.mobileNumber.toString().includes(q)) ||
        (row.poojaname && row.poojaname.toLowerCase().includes(q))
      );
    });
  }, [data, searchQuery]);

  // Analytics Calculations
  const totalRevenue = useMemo(() => {
    return filteredData.reduce((sum, r) => sum + (Number(r.amount) || 0), 0);
  }, [filteredData]);

  const totalBookings = filteredData.length;
  const avgAmount = totalBookings > 0 ? Math.round(totalRevenue / totalBookings) : 0;
  const uniqueCustomers = useMemo(() => {
    return new Set(filteredData.map(r => r.mobileNumber).filter(Boolean)).size;
  }, [filteredData]);

  // Pagination calculation
  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
  const indexOfFirstRecord = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(
    indexOfFirstRecord,
    indexOfFirstRecord + itemsPerPage
  );

  // Smart Pagination range logic
  const getPaginationItems = () => {
    if (totalPages <= 8) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (currentPage <= 4) {
      return [1, 2, 3, 4, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    if (currentPage >= totalPages - 3) {
      return [1, 2, 3, 4, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
  };

  return (
    <div 
    //style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fcfaf8' }}
    >
      <Sidebar />

      <div
        id="main"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        }}
      >
        <div
          style={{
            padding: isMobile ? '16px' : '28px',
            maxWidth: '1280px',
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {/* Header & Date Pickers */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              justifyContent: 'space-between',
              gap: '16px',
              width: '100%'
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile ? '22px' : '26px',
                  fontWeight: '700',
                  color: '#111827',
                  fontFamily: "'Cinzel', serif"
                }}
              >
                Pooja Ticket Booking Report
              </h2>
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
                Comprehensive analytics and individual ticket ledger
              </p>
            </div>

            {/* Date Controls */}
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '10px',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  backgroundColor: '#ffffff',
                  padding: '8px 12px',
                  borderRadius: '12px',
                  border: '1px solid #ffedd5',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                }}
              >
                <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>From</span>
                <input
                  type="date"
                  value={date_1}
                  onChange={(e) => setDate1(e.target.value)}
                  style={{
                    outline: 'none',
                    border: 'none',
                    color: '#374151',
                    backgroundColor: 'transparent',
                    fontSize: '13px',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  backgroundColor: '#ffffff',
                  padding: '8px 12px',
                  borderRadius: '12px',
                  border: '1px solid #ffedd5',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                }}
              >
                <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>To</span>
                <input
                  type="date"
                  value={date_2}
                  onChange={(e) => setDate2(e.target.value)}
                  style={{
                    outline: 'none',
                    border: 'none',
                    color: '#374151',
                    backgroundColor: 'transparent',
                    fontSize: '13px',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                />
              </div>

              <button
                onClick={handleDateSubmit}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '10px 18px',
                  borderRadius: '12px',
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#ffffff',
                  background: 'linear-gradient(135deg, #f97316, #c2410c)',
                  boxShadow: '0 4px 16px rgba(249, 115, 22, 0.3)',
                  border: 'none',
                  cursor: 'pointer',
                  width: isMobile ? '100%' : 'auto'
                }}
              >
                <span>Submit</span>
              </button>

              {data.length > 0 && (
                <button
                  onClick={handleGeneratePDF}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    padding: '10px 18px',
                    borderRadius: '12px',
                    border: '1px solid #fed7aa',
                    backgroundColor: '#ffffff',
                    color: '#c2410c',
                    fontSize: '13px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                    width: isMobile ? '100%' : 'auto'
                  }}
                >
                  {Icons.FileBarChart(16)}
                  <span>Print</span>
                </button>
              )}
            </div>
          </div>

          {/* KPI Cards (Displays metrics when filtered data exists) */}
          {data.length > 0 && (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
                gap: '16px',
                width: '100%'
              }}
            >
              {[
                { label: 'Total Revenue', value: `₹${totalRevenue.toLocaleString()}`, icon: Icons.IndianRupee, color: '#ea580c' },
                { label: 'Total Tickets', value: totalBookings, icon: Icons.Ticket, color: '#d97706' },
                { label: 'Active Customers', value: uniqueCustomers, icon: Icons.Users, color: '#16a34a' },
                { label: 'Avg Ticket Value', value: `₹${avgAmount.toLocaleString()}`, icon: Icons.TrendingUp, color: '#7c3aed' },
              ].map((k) => (
                <div
                  key={k.label}
                  style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    border: '1px solid #ffedd5',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                  }}
                >
                  <div
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      backgroundColor: `${k.color}18`,
                      color: k.color
                    }}
                  >
                    {k.icon(20)}
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#111827' }}>
                      {k.value}
                    </p>
                    <p style={{ margin: '2px 0 0 0', fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>
                      {k.label}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Detailed Table & Pagination */}
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              border: '1px solid #ffedd5',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
              width: '100%',
              overflow: 'hidden'
            }}
          >
            {/* Filters Toolbar */}
            <div
              style={{
                padding: '16px 20px',
                borderBottom: '1px solid #ffedd5',
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: isMobile ? 'stretch' : 'center',
                gap: '12px',
                backgroundColor: '#ffffff'
              }}
            >
              <div style={{ position: 'relative', flex: 1, maxWidth: isMobile ? '100%' : '420px' }}>
                <span
                  style={{
                    position: 'absolute',
                    left: '14px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#9ca3af',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {Icons.Search(16)}
                </span>
                <input
                  placeholder="Search by Customer Name, Mobile, or Pooja..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                  style={{
                    width: '100%',
                    padding: '11px 16px 11px 40px',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#4b5563' }}>
                <span>Show</span>
                <select
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                  style={{
                    padding: '8px 12px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    backgroundColor: '#ffffff',
                    color: '#1f2937',
                    outline: 'none',
                    cursor: 'pointer'
                  }}
                >
                  <option value={5}>5</option>
                  <option value={8}>8</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                </select>
                <span>entries</span>
              </div>
            </div>

            {/* Table */}
            <div id="printable-table" style={{ width: '100%', overflowX: 'auto' }}>
              <table
                style={{
                  width: '100%',
                  minWidth: '750px',
                  borderCollapse: 'collapse',
                  textAlign: 'left'
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: 'rgba(255, 247, 237, 0.6)',
                      borderBottom: '1px solid #ffedd5',
                      fontSize: '12px',
                      fontWeight: '600',
                      color: '#374151',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }}
                  >
                    <th style={{ padding: '14px 20px', width: '70px' }}>S.No</th>
                    <th style={{ padding: '14px 20px' }}>Customer Name</th>
                    <th style={{ padding: '14px 20px' }}>Mobile Number</th>
                    <th style={{ padding: '14px 20px' }}>Pooja Name</th>
                    <th style={{ padding: '14px 20px', textAlign: 'right' }}>Amount</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: '14px' }}>
                  {loading ? (
                    <tr>
                      <td
                        colSpan={5}
                        style={{
                          textAlign: 'center',
                          padding: '40px 0',
                          color: '#6b7280',
                          fontSize: '14px'
                        }}
                      >
                        Loading report data...
                      </td>
                    </tr>
                  ) : paginatedData.length > 0 ? (
                    paginatedData.map((row, index) => {
                      const serialNumber = indexOfFirstRecord + index + 1;
                      return (
                        <tr
                          key={index}
                          style={{
                            borderBottom: '1px solid #fff7ed',
                            backgroundColor: '#ffffff'
                          }}
                        >
                          <td style={{ padding: '16px 20px', color: '#6b7280', fontWeight: '500', fontSize: '13px' }}>
                            {serialNumber}
                          </td>
                          <td style={{ padding: '16px 20px', fontWeight: '600', color: '#111827' }}>
                            {row.customerName}
                          </td>
                          <td style={{ padding: '16px 20px', fontFamily: 'monospace', color: '#4b5563', fontSize: '13px' }}>
                            {row.mobileNumber}
                          </td>
                          <td style={{ padding: '16px 20px' }}>
                            <span
                              style={{
                                display: 'inline-block',
                                padding: '4px 10px',
                                borderRadius: '9999px',
                                fontSize: '12px',
                                fontWeight: '500',
                                backgroundColor: '#fff7ed',
                                color: '#c2410c',
                                border: '1px solid #ffedd5'
                              }}
                            >
                              {row.poojaname}
                            </span>
                          </td>
                          <td style={{ padding: '16px 20px', fontWeight: '700', color: '#111827', textAlign: 'right' }}>
                            ₹{Number(row.amount || 0).toLocaleString()}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan={5}
                        style={{
                          textAlign: 'center',
                          padding: '40px 0',
                          color: '#9ca3af',
                          fontSize: '14px'
                        }}
                      >
                        No report records found. Please select a date range and click submit.
                      </td>
                    </tr>
                  )}
                </tbody>
                {filteredData.length > 0 && !loading && (
                  <tfoot>
                    <tr
                      style={{
                        backgroundColor: 'rgba(255, 247, 237, 0.8)',
                        borderTop: '1px solid #ffedd5',
                        fontSize: '14px',
                        fontWeight: '700'
                      }}
                    >
                      <td colSpan={4} style={{ padding: '14px 20px', color: '#374151' }}>
                        Total Filtered Revenue
                      </td>
                      <td style={{ padding: '14px 20px', color: '#c2410c', textAlign: 'right' }}>
                        ₹{totalRevenue.toLocaleString()}
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && !loading && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '12px',
                  padding: '16px 20px',
                  borderTop: '1px solid #ffedd5',
                  backgroundColor: '#ffffff',
                  flexWrap: 'wrap'
                }}
              >
                <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>
                  Showing {indexOfFirstRecord + 1} to{' '}
                  {Math.min(indexOfFirstRecord + itemsPerPage, filteredData.length)} of {filteredData.length} entries
                </p>

                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                  {/* First Page */}
                  <button
                    onClick={() => setCurrentPage(1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: '6px 10px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                      opacity: currentPage === 1 ? 0.4 : 1
                    }}
                  >
                    « First
                  </button>

                  {/* Previous */}
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                      opacity: currentPage === 1 ? 0.4 : 1
                    }}
                  >
                    Prev
                  </button>

                  {/* Page Numbers & Ellipsis */}
                  {getPaginationItems().map((item, index) => {
                    if (item === '...') {
                      return (
                        <span
                          key={`ellipsis-${index}`}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '28px',
                            height: '32px',
                            fontSize: '14px',
                            color: '#9ca3af',
                            userSelect: 'none'
                          }}
                        >
                          ...
                        </span>
                      );
                    }

                    const isCurrent = currentPage === item;
                    return (
                      <button
                        key={`page-${item}`}
                        onClick={() => setCurrentPage(item)}
                        style={{
                          minWidth: '32px',
                          height: '32px',
                          padding: '0 6px',
                          borderRadius: '8px',
                          fontSize: '12px',
                          fontWeight: isCurrent ? '700' : '500',
                          cursor: 'pointer',
                          border: isCurrent ? 'none' : '1px solid #e5e7eb',
                          backgroundColor: isCurrent ? '#f97316' : '#ffffff',
                          color: isCurrent ? '#ffffff' : '#4b5563',
                          boxShadow: isCurrent ? '0 2px 8px rgba(249, 115, 22, 0.3)' : 'none'
                        }}
                      >
                        {item}
                      </button>
                    );
                  })}

                  {/* Next */}
                  <button
                    onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                      opacity: currentPage === totalPages ? 0.4 : 1
                    }}
                  >
                    Next
                  </button>

                  {/* Last Page */}
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: '6px 10px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                      opacity: currentPage === totalPages ? 0.4 : 1
                    }}
                  >
                    Last »
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Report;